module.exports = __webpack_public_path__ + "assets/img/typeIcon-1-red.55a5dde7.svg";